// Re-export for backward compatibility
// The actual translations are now split into per-language files in ./translations/
import { en, type TranslationKey, getTranslations, loadTranslations } from "./translations/index";
import { type Language } from "./constants";
export type { Language } from "./constants";
export type { TranslationKey };

// Provide sync access with English fallback for backward compat
export const translations: Record<Language, Record<string, string>> = new Proxy(
  { en } as Record<Language, Record<string, string>>,
  {
    get(target, prop: string) {
      if (prop === "en") return en;
      return getTranslations(prop as Language);
    },
  }
);

export { loadTranslations };
